import { createBrowserClient, readViteSupabaseEnv } from '@careandkey/shared';

// Single browser Supabase client for the back-office + owner portal.
export const supabase = createBrowserClient(readViteSupabaseEnv(import.meta.env));
